
<template>
  <card>
    <div v-if="!err">

    <h4 slot="header" class="card-title">
      Tüm Tesisler 
      <router-link v-b-tooltip title="Yeni Sayfa Oluştur" :to="{ path: 'facilities/add'}" class="btn btn-primary btn-fill float-md-right" tag="li"><i class="fas fa-plus"></i> Yeni Tesis</router-link>
    </h4>
    <table class="table table-hover table-striped table-bordered mb-0">
      <caption >Toplam: {{total}}</caption>
      <thead class="thead-dark">
        <th>Sayfa</th>
        <th>Yayın Tarihi</th>
        <th style="width:15%">İşlemler</th>
      </thead>
      <tbody>
        <tr v-for="item in table" :key="item.id">
          <td>{{item.name}}</td>
          <td>{{item.created | moment("Do/MM/YYYY HH:mm:ss")}} </td>
          <td class="d-flex justify-content-around align-items-center">
            <router-link :to="{ path: 'facilities/edit/'+item.id}" v-b-tooltip title="Düzenle" class="btn btn-primary btn-fill btn-xs" tag="li"><i class="fas fa-edit"></i></router-link>
            <a href="javascript:void(0)" class="btn btn-xs btn-danger btn-fill" v-if="item.status !== 4 " v-on:click="changeStatus(item.id,4)" v-b-tooltip title="Yayından Kaldır" id="deactivate-item.id"><i class="fas fa-eye-slash"></i></a>
            <a href="javascript:void(0)" class="btn btn-xs btn-success btn-fill" v-if="item.status === 4" v-b-tooltip v-on:click="changeStatus(item.id,1)" title="Yayına al" id="activate-item.id"><i class="fas fa-eye"></i></a>
          </td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation small">

      <ul class="pagination justify-content-end">
        <li class="page-item" v-bind:class="{disabled: isFirst()}"><a class="page-link" v-on:click="getPosts(page - 1,type)" >Öncesi</a></li>
        <li class="page-item" v-for="current in pageCount" v-if="isInScope(current)" v-bind:class="{active: isActive(current), 'mr-2': current == 1, 'ml-2': current == pageCount.length}" :key="current"><a href="javascript:void(0)" class="page-link active" v-on:click="getPosts(current,type)">{{current}}</a></li>
        <li class="page-item" v-bind:class="{disabled: isLast()}"><a class="page-link" v-on:click="getPosts(page + 1,type)">Sonrası</a></li>
      </ul>
    </nav>
    </div>
  <div v-if="err">
{{err}}
  </div>

  </card>
</template>
<script>
  import Card from 'src/components/UIComponents/Cards/Card.vue'

  export default {
    data: function () {
      return {
        post:{
          status:1
        },
        table: null,
        total: 0,
        limit: localStorage.getItem('filterLimit'),
        page: 1,
        pageCount: null,
        navigation: true,
        type: 'Facilities',
        viewCounts: [],
        err:null
      }
    },
    components: {
      Card
    },

    methods: {
      changeStatus: function(id,status){
        this.toggleLoader()
        this.post.status = status
        this.$http.post('/api/posts/edit/' + id, this.post).then(
          response => {
            if(!status){
              this.notifier('top', 'right', 'warning', 'Sayfa Yayından Kaldırıldı')
            }else{
              this.notifier('top', 'right', 'success', 'Sayfa Yayınlandı')
            }
            
            this.getPosts(this.page,this.type)
            this.toggleLoader()
          },
          e => {
                     this.toggleLoader();
                                                                                                          if(!e.body.Error){
              this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
            }else{
              this.notifier('top', 'right', 'danger', e.body.Error)

            }
          })
      },
      isInScope: function(c){
        if(c === 1){
          return true
        }
        if(c === this.pageCount.length){
          return true
        }
        if(c - this.page > 3 || this.page - c > 3){
          return false;
        }
        return true
      },
      isActive: function (v) {
        return v === this.page
      },
      isFirst: function () {
        return this.page === 1
      },
      isLast: function () {
        return this.page === Math.ceil(this.total / this.limit)
      },
      getPosts: function (p = 1, t = 'Facilities') {
        this.toggleLoader()
        this.type = t
        var url = '/api/filter/posts/post-type/' + this.type + '/limit/' + this.limit + '/page/' + p
        this.$http
        .get(url)
        .then(
          response => {
            this.table = response.body.data
            this.total = response.body.meta.total
            this.page = p
            this.pageCount = []
            for (var i = 0; i < this.total / this.limit; i++) {
              this.pageCount.push(i + 1)
            }
            this.toggleLoader()
          },
          er => {
                    this.toggleLoader();

if(!er.body.Error){
             this.notifier(
              'top',
              'right',
              'danger',
              'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.'
              )
            }else{
              this.err = er.body.Error;
            this.notifier(
              'top',
              'right',
              'danger',
              er.body.Error
              )
            }
          }
          )
      },
      toggleNavigation () {
        var button = event.target
        if (this.navigation) {
          button.innerHTML = '<i class="fas fa-caret-down"></i>'
          this.navigation = false
        } else {
          button.innerHTML = '<i class="fas fa-caret-up"></i>'
          this.navigation = true
        }
      },
      toggleNewPostPanel (event) {
        event.stopPropagation()
        if (document.getElementById('new-post').classList.contains('d-none')) {
          document.getElementById('new-post').classList.remove('d-none')
        } else {
          document.getElementById('new-post').classList.add('d-none')
        }
      }
    },
    mounted: function () {
      this.$nextTick(function () {
        this.getPosts()
      })
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/PostModules/Facilities/Index.vue